import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import config from "../../config";
import LeftSidebar from "../Common/LeftSidebar";
import Loader from "../Common/Loader";
import RightIconMenu from "../Common/RightIconMenu";
import RightSidebar from "../Common/RightSidebar";

import { username, role, token } from "../Actions/AuthAction";
import ProfileForms from "../profile-forms";
import { CandidateAppliedDriveList } from "../Actions/DriveAction";
import { listDrive } from "../Actions/DriveAction";

const CandidateDashboard = ({ profileCompletetionStatus }) => {
  const [totalDrive, setTotalDrive] = useState(0);
  const [totalapplieddrive, setTotalAppliedDrives] = useState(0);
  const [totalselecteddrive, setTotalSelectedDrives] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listDrive({
      loginusertoken: token(),
      page: "1",
      startdate: "",
      enddate: "",
      instid: "",
      venuestatus: "",
      drivetype: "",
      drivestatus: "",
    }).then((res) => {
      if (res.status) {
        setTotalDrive(res.totaldata);
        setLoading(false);
      }
      else {
        setTotalDrive(0);
        setLoading(false);
      }
    });

    CandidateAppliedDriveList({
      loginusertoken: token(),
      page: 1,
      applystatus: 1,
    }).then((res) => {
      setTotalAppliedDrives(res.totaldata);
      setLoading(false);
    });

    CandidateAppliedDriveList({
      loginusertoken: token(),
      page: 1,
      applystatus: 2,
    }).then((res) => {
      setTotalSelectedDrives(res.totaldata);
      setLoading(false);
    });
  });

  return (
    <React.Fragment>
      {loading && <Loader />}
      <ProfileForms show={profileCompletetionStatus === "2"} />
      <div class="row mt-5">
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/drivelist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Drives
                  <span class="d-block text-danger mt-4">{totalDrive}</span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-university"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>

        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/applieddrivelist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Applied Drives
                  <span class="d-block text-danger mt-4">
                    {totalapplieddrive}
                  </span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-university"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card-custom card mb-4">
            <Link to="/selecteddrivelist" className="newlinks">
              <div class="card-body d-flex justify-content-between">
                <h5>
                  Selected Drives
                  <span class="d-block text-danger mt-4">
                    {totalselecteddrive}
                  </span>
                </h5>
                <h2 class="text-danger dashboardicon">
                  {" "}
                  <i class="d-block text-danger dashboardiconimg fas fa-university"></i>
                </h2>
              </div>
            </Link>
          </div>
        </div>
      </div>
      {/* <div class="card mb-4">
        <div class="card-header">Table</div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Position</th>
                  <th>Office</th>
                  <th>Age</th>
                  <th>Start date</th>
                  <th>Salary</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Shad Decker</td>
                  <td>Regional Director</td>
                  <td>Edinburgh</td>
                  <td>51</td>
                  <td>2008/11/13</td>
                  <td>$183,000</td>
                </tr>
                <tr>
                  <td>Michael Bruce</td>
                  <td>Javascript Developer</td>
                  <td>Singapore</td>
                  <td>29</td>
                  <td>2011/06/27</td>
                  <td>$183,000</td>
                </tr>
                <tr>
                  <td>Donna Snider</td>
                  <td>Customer Support</td>
                  <td>New York</td>
                  <td>27</td>
                  <td>2011/01/25</td>
                  <td>$112,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-between">
            <h6>Showing 1-10 results from 50</h6>
            <ul class="d-flex justify-content-between list-unstyled pagination">
              <li class="px-1">
                <a href="#">
                  <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                </a>
              </li>
              <li class="px-1 active">
                <a href="#">1</a>
              </li>
              <li class="px-1">
                <a href="#">2</a>
              </li>
              <li class="px-1">
                <a href="#">3</a>
              </li>
              <li class="px-1">
                <a href="#">4</a>
              </li>
              <li class="px-1">
                <a href="#">5</a>
              </li>
              <li class="px-1">
                <a href="#">
                  <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
};
export default CandidateDashboard;
